module.exports = __webpack_public_path__ + "static/img/10.11a9c18e.png";